// IST (Asia/Kolkata, UTC+05:30) formatting helpers — used across the app.

const IST_OFFSET_MINUTES = 330; // +5:30

/** Format an ISO/UTC string as a human-readable IST string. */
export const fmtIST = (iso, opts = {}) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      ...opts,
    }) + " IST";
  } catch {
    return iso;
  }
};

/** Format only the time (HH:MM) in IST. */
export const relTime = (iso) => {
  if (!iso) return "";
  try {
    const diff = Date.now() - new Date(iso).getTime();
    const s = Math.max(0, Math.round(diff / 1000));
    if (s < 60) return "just now";
    const m = Math.round(s / 60);
    if (m < 60) return `${m} min ago`;
    const h = Math.round(m / 60);
    if (h < 24) return `${h} hr ago`;
    const d = Math.round(h / 24);
    return `${d} day${d > 1 ? "s" : ""} ago`;
  } catch { return ""; }
};


export const fmtISTTime = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  } catch { return ""; }
};

/** Convert an ISO UTC string to a `datetime-local` value that shows IST wall-clock. */
export const toISTDatetimeLocal = (iso) => {
  if (!iso) return "";
  try {
    const utcMs = new Date(iso).getTime();
    const ist = new Date(utcMs + IST_OFFSET_MINUTES * 60_000);
    const pad = (n) => String(n).padStart(2, "0");
    return `${ist.getUTCFullYear()}-${pad(ist.getUTCMonth() + 1)}-${pad(ist.getUTCDate())}T${pad(ist.getUTCHours())}:${pad(ist.getUTCMinutes())}`;
  } catch { return ""; }
};

/** Convert a `datetime-local` value (entered as IST wall-clock) back to an ISO UTC string. */
export const fromISTDatetimeLocal = (local) => {
  if (!local) return null;
  try {
    // local is "YYYY-MM-DDTHH:MM" — interpret as IST
    const [datePart, timePart] = local.split("T");
    const [y, mo, d] = datePart.split("-").map(Number);
    const [h, mi] = timePart.split(":").map(Number);
    // IST wall clock -> UTC ms
    const utcMs = Date.UTC(y, mo - 1, d, h, mi) - IST_OFFSET_MINUTES * 60_000;
    return new Date(utcMs).toISOString();
  } catch { return null; }
};
